if (!window.Promise) window.Promise = require('promise-polyfill');
if (!window.fetch) window.fetch = require('unfetch');

Object.assign = require('object-assign');
require('intersection-observer');
// This is available locally because everyone who made one doesn't understand
// npm, apparently
require('./polyfills/classlist.js');



//////////////////
// WEBPACK FOOTER
// /Users/ryan/Projects/texastribune/2018-congressional-primaries-to-watch/config/polyfills.js
// module id = 1
// module chunks = 0